import React, {useEffect} from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as EditorFunctions from '../utilities/EditorFunctions';
import * as SharedAcross from '../utilities/SharedAcross';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import IconSelector from '../StockItems/IconSelector';
import SelectorData from '../StockItems/SelectorData';
import Form2 from '../Tabs/Form2';
import Samples from './Samples';
import Samples2 from './Samples2';
import DistanceStyle from './DistanceStyle';
import CommonStylus from './CommonStylus';
import FontOptions from './FontOptions';
import RFormulaPiece from './RFormulaPiece';
import ModifiersStylus from './ModifiersStylus';
import SingleColorStylus from './SingleColorStylus';
import DropdownStylus from './DropdownStylus';
import FontFamilyStylus from './FontFamilyStylus';
import NavBarSource from './NavBarSource';
// import ZIndexStylus from './ZIndexStylus';

function App(props) {

  var itemEdited = props.itemEdited;
  var refObject = props.refObject;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var columnWidth = props.columnWidth;
  var toggle = props.toggle;
  var setToggle = props.setToggle;
  var addToExtraScreen = props.addToExtraScreen;
  var error = props.error;
  var objPath = props.objPath;
  var organicChanges = props.organicChanges;
  var currentList = props.currentList;
  var thingsToChange = props.thingsToChange;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var screenSize = props.screenSize;
  var userNos = props.userNos;
  var userID = props.userID;
  var mostRecentFont = props.mostRecentFont;
  var setMostRecentFont = props.setMostRecentFont;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var changeTab = props.changeTab;
  var setItemEdited = props.setItemEdited;
  var screenRefs = props.screenRefs;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var highlightAnItem = props.highlightAnItem;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;
  var flashHighlight = props.flashHighlight;
  var setFlashHighlight = props.setFlashHighlight;
  var centerZoom = props.centerZoom;
  var fakeInternalVariables = props.fakeInternalVariables;
  var chains = props.chains
  var setLastEdited = props.setLastEdited;

  var origStylePath = objPath.concat(['s']);

  var item = CoreFns.goDownPath(currentList, objPath);

  if (isShowingSomeDropDown && isShowingSomeDropDown.t === 'move'){
    origStylePath = objPath.concat(['pos']);
  // }else if (isShowingSomeDropDown && isShowingSomeDropDown.t === 'crop'){
  //   origStylePath = objPath.concat(['info']);
  }else if (isShowingSomeDropDown && (isShowingSomeDropDown.t === 'moveScreen')){
    origStylePath = objPath;
  }else if (isShowingSomeDropDown){
    if (objPath.length === 3 && objPath[2] === 'nv'){
      if (item.on !== 1){
        origStylePath = ['cn', item.on, 'nv', 's'];
      }
    }
  }

  useEffect(()=>{
    if (error){
      var errorPart = EditorFunctions.getErrorPart(error.loc, error.screenPath);
      var llRef = leftColRefs[errorPart[1]];
      if (llRef && llRef.current){
        llRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var errorString = CoreFns.errorString(error);

  var currentScreenStyle = {};
  var origCurrentScreenStyle = {};
  var stylePath;
  var styleWarningRow = [];


  try{

    function clickCommon(){
      setIsShowingSomeDropDown({t:'common'});
    }

    origCurrentScreenStyle = CoreFns.goDownPath(currentList, origStylePath, 0);
    if (origCurrentScreenStyle.te && isShowingSomeDropDown && (isShowingSomeDropDown.t === 'style' || isShowingSomeDropDown.t === 'spanFontFamily' || isShowingSomeDropDown.t === 'textColor' || isShowingSomeDropDown.t === 'legendColor' || isShowingSomeDropDown.t === 'backgroundColor' || isShowingSomeDropDown.t === 'border')){
        var teSet = CoreFns.goDownPath(currentList, ['st', origCurrentScreenStyle.te.v]);
        stylePath = ['st', origCurrentScreenStyle.te.v, 's'];
        styleWarningRow = [<tr key='warn'><td><p className='lead mb-0'>Styles changed here will affect all styles of the {teSet.n} reuse. Click <span style={{cursor:'pointer'}} onClick={clickCommon}><u>here</u></span> to change that.</p></td></tr>]
  //
        try{
          currentScreenStyle = CoreFns.goDownPath(currentList, stylePath, 0);
        }catch(err){
          return null;
        }
    }else{
      currentScreenStyle = origCurrentScreenStyle;
      stylePath = origStylePath;
    }
  }catch(err){
    return null;
  }

  function getStylePath(whatDrop){
    var isTo = StyleFunctions.isToIgnore(whatDrop);
    if (isInfo(whatDrop)){
      return objPath.concat(['info']);
    }else if (isTo){
      return origStylePath;
    }else{
      return stylePath;
    }
  }


  function cleanAGroup(aGroupOfItems){
    for (var i = 0; i < aGroupOfItems.length; i++){
      var anItem = aGroupOfItems[i];
      var itemToCheck = anItem.i;
      var itemT = anItem.t;
      if (itemT === 'objectName'  ){
      }else{
        if (itemT === 'src' || itemT === 'srcVideo'){
          itemToCheck = 'src';
        }
        var thisPath = stylePath.concat([itemToCheck]);
        var p1 = CoreFns.checkPathGotError(thisPath, errorString);
        if (p1){
          anItem.e = true;
          return true;
        }
      }
    }
    return false;
  }  

  function isInfo(whatDrop){
    if (whatDrop === 'sca' || whatDrop === 'cL' || whatDrop === 'cR' || whatDrop === 'cT' || whatDrop === 'cB'){
      return true;
    }else{
      return false;
    }
  }
  cleanAGroup(thingsToChange);
  
  function getOrig(whatDrop){
    if (whatDrop === 'text' || whatDrop === 'src'){
      return ResponsiveFns.getOrigFn(whatDrop, origCurrentScreenStyle);
    }else if (isInfo(whatDrop)){
      return ResponsiveFns.getOrigFn(whatDrop, item.info);
    }else{
      return ResponsiveFns.getOrigFn(whatDrop, currentScreenStyle);
    }
  }

  function formulaPiece(anItem, title){

    var questions = [{q:title, t:anItem.f, i:anItem.i, f:1, c:[]}];
    return <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={questions} header={stylePath} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={true} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>

  }

  function toggler(i, whatDrop, addChanges){
    return function(e){
      setLastEdited(objPath.join(' '));
      setTimeout(function(){ setLastEdited(''); }, 100);
      var orig = getOrig(whatDrop);
      if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 4 && whatDrop === 'buttonColor'){
        setDoingWhat({t:'guide',v:5});
      }
      if (i === orig){
        submitGeneric({t:'raw', v:false}, whatDrop, false);
      }else if (i === 1){
        submitGeneric({t:'int', v:1}, whatDrop, addChanges);
      }else if (i === 0){
        submitGeneric({t:'int', v:0}, whatDrop, addChanges);
      }else{
        submitGeneric({t:'raw', v:i}, whatDrop, addChanges);
      }
    }
  }


  function addGenericRow(anItem){
    if (anItem.t === 'msg'){
      return <td><p className='lead mb-0'>{anItem.n}</p></td>
    }else if (anItem.t === 'instructions'){
      return (<td>{anItem.n}</td>)
//
    }else if (anItem.t === 'listOfItems'){
      var formulaP3 = formulaPiece(anItem, 'List of Items');
      
//
      return (<td>{anItem.n}<center>{formulaP3}
            </center></td>)

    }else if (anItem.t === 'common'){

      return <CommonStylus origCurrentScreenStyle={origCurrentScreenStyle} currentList={currentList} stylePath={stylePath} organicChanges={organicChanges} anItem={anItem} userNos={userNos} currentScreenStyle={currentScreenStyle} origStylePath={origStylePath}/>
//
    // }else if (anItem.t === 'zIndex'){

    //   return <ZIndexStylus currentList={currentList} objPath={objPath} organicChanges={organicChanges}/>

    }else if (anItem.t === 'dropDown'){

      return <DropdownStylus anItem={anItem} getOrig={getOrig} submitGeneric={submitGeneric}/>

//        
    }else if (anItem.t === 'data'){

      return (<SelectorData objPath={objPath} organicChanges={organicChanges} currentList={currentList} userNos={userNos} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} columnWidth={columnWidth - 20} addToExtraScreen={addToExtraScreen} error={error} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>)
//        
    }else if (anItem.t === 'icon'){

      return (<td><IconSelector columnWidth={columnWidth - 20} currentScreenStyle={currentScreenStyle} submitGeneric={submitGeneric} currentList={currentList} insetWidth={insetWidth} insetHeight={insetHeight} screenSize={screenSize} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} stylePath={stylePath} organicChanges={organicChanges}/></td>)
//
    }else if (anItem.t === 'modifiers'){

      return <ModifiersStylus chains={chains} itemEdited={itemEdited} item={item} currentList={currentList} objPath={objPath} changeTab={changeTab} setIsShowingSomeDropDown={setIsShowingSomeDropDown} setItemEdited={setItemEdited} screenRefs={screenRefs} leftColRefs={leftColRefs} flashHighlight={flashHighlight} setFlashHighlight={setFlashHighlight} centerZoom={centerZoom} fakeInternalVariables={fakeInternalVariables} />
    }else if (anItem.t === 'navBarSource'){

      return <NavBarSource currentList={currentList} objPath={objPath} organicChanges={organicChanges} setItemEdited={setItemEdited} userNos={userNos} />

    }else if (anItem.t === 'form'){

      var questions = [{q:anItem.n, t:anItem.fo, i:anItem.i, f:anItem.f, h:anItem.h, c:anItem.c}];
      return <td style={{width:columnWidth, maxWidth:columnWidth, wordWrap:'break-word'}}><Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={questions} header={stylePath} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={true} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/></td>
//
//
    }else if (anItem.t === 'formDirect'){

      return <td><Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={[anItem.ins]} header={stylePath} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={true} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/></td>
//
    }else if (anItem.t === 'spanFontFamily'){
      return <FontFamilyStylus getOrig={getOrig} submitGeneric={submitGeneric} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} addToExtraScreen={addToExtraScreen} />

    }else if (anItem.t === 'rFormula'){
      return <RFormulaPiece getOrig={getOrig} formulaPieceInGeneral={formulaPieceInGeneral} objPath={objPath} currentList={currentList} errorString={errorString} organicChanges={organicChanges} stylePath={stylePath} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} addToExtraScreen={addToExtraScreen}/>
  //
    }else if (anItem.t === 'distance'){
      return <DistanceStyle getOrig={getOrig} item={item} objPath={objPath} anItem={anItem} isInfo={isInfo} submitGeneric={submitGeneric} currentScreenStyle={currentScreenStyle} setMultipleX={setMultipleX} formulaPiece={formulaPiece} insetWidth={insetWidth} insetHeight={insetHeight} stylePath={stylePath} organicChanges={organicChanges} formulaPieceInGeneral={formulaPieceInGeneral} screenSize={screenSize} addToExtraScreen={addToExtraScreen}/>

    }else if (anItem.t === 'color'){
      return <SingleColorStylus currentScreenStyle={currentScreenStyle} currentList={currentList} anItem={anItem} formulaPieceInGeneral={formulaPieceInGeneral} submitGeneric={submitGeneric} columnWidth={columnWidth} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} addToExtraScreen={addToExtraScreen} stylePath={stylePath} organicChanges={organicChanges}/>
//        

    }else if (anItem.t === 'fontColor' || anItem.t === 'fontSize' || anItem.t === 'fontFamily'){
      return <FontOptions itemEdited={itemEdited} userID={userID} organicChanges={organicChanges} currentList={currentList} refObject={refObject} anItem={anItem} toggle={toggle} setToggle={setToggle} insetWidth={insetWidth} insetHeight={insetHeight} screenSize={screenSize} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} isShowingSomeDropDown={isShowingSomeDropDown} setIsShowingSomeDropDown={setIsShowingSomeDropDown} columnWidth={columnWidth} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} addToExtraScreen={addToExtraScreen} />

  
    }else if (anItem.t === 'samples2'){
      return <Samples2 anItem={anItem} getOrig={getOrig} stylePath={stylePath} screenSize={screenSize} currentScreenStyle={currentScreenStyle} getStylePath={getStylePath} organicChanges={organicChanges} toggler={toggler}/>
//        
    }else if (anItem.t === 'samples'){
      return <Samples anItem={anItem} getOrig={getOrig} toggler={toggler} highlightAnItem={highlightAnItem}/>
    }else if (anItem.t === 'tags'){

      var tag = '';
      if (currentScreenStyle && currentScreenStyle.tags && currentScreenStyle.tags[anItem.i]){
        tag = currentScreenStyle.tags[anItem.i];
      }
      function clickTag(e){
        var p = window.prompt('New Tag? (Integer between 1 and 3)', tag);
        var isInt = SharedAcross.isIntegerText(p);
        if (isInt){
          if (+p > 0 && +p < 4){
            organicChanges([{t:'w',w:stylePath.concat(['tags', anItem.i]),n:+p}])
          }
        }
      }

      var aTag = tag;
      if (!tag){
        aTag = 'None';
      }

      return <center><p className='lead mb-0' onClick={clickTag} style={{cursor:'pointer', textDecoration:'underline'}}>Tag : {aTag}</p></center>
//
      // return <Samples anItem={anItem} getOrig={getOrig} toggler={toggler} highlightAnItem={highlightAnItem}/>
    }else{
      console.log(anItem);
    }
  }
//

  function formulaPieceInGeneral(pointer, title, type){
    return function(e){
      ResponsiveFns.formulaPieceInGeneralX(pointer, title, type, organicChanges, stylePath, currentScreenStyle, addToExtraScreen);      
    }
  }


  function submitGeneric(ans, whatDrop, addChanges){
    var stylePath1 = getStylePath(whatDrop);
    var srcPath = stylePath1.concat([whatDrop]);
    var changes;
    if (ans.v === false){
      changes = [{t:'r',w:stylePath1,i:whatDrop}]
    }else{
      changes = [{t:'w',w:srcPath,n:ans}];
    }
    var toAdd = [];
    if (addChanges){
      toAdd = addChanges;
    }

    if (whatDrop === 'borderColor'){
      var origBorderStyle = getOrig('borderStyle');
      var origBorderWidth = getOrig('borderWidth');

      if (!origBorderWidth){
        toAdd.push({t:'w',w:stylePath1.concat(['borderWidth']),n:{t:'int',v:1}});
      }
      if (origBorderStyle === false){
        toAdd.push({t:'w',w:stylePath1.concat(['borderStyle']),n:{t:'raw',v:'solid'}});
      }
    }else if (whatDrop === 'borderStyle'){
      var origBorderColor1 = getOrig('borderColor');
      var origBorderWidth1 = getOrig('borderWidth');
      if (origBorderColor1 === false){
        toAdd.push({t:'w',w:stylePath1.concat(['borderColor']),n:{t:'raw',v:'rgb(0,0,0)'}});
      }
      if (!origBorderWidth1){
        toAdd.push({t:'w',w:stylePath1.concat(['borderWidth']),n:{t:'int',v:1}});
      }
    }
    organicChanges(changes.concat(toAdd));
  }



  var rows1 = thingsToChange.map((aThingToChange, index)=>{
    return <tr key={index} style={{color:'#CCC'}}>{addGenericRow(aThingToChange)}</tr>
  })
//
  return <TableWrapRowsBoot rows={styleWarningRow.concat(rows1)} />
}

function setMultipleX(input){
    input.f();
}
//
export default App;
